/* @flow */
import * as React from 'react';
import Header from 'components/Header.jsx';
import HeaderLight from 'components/HeaderLight.jsx';
import cx from 'classnames';

import './styles/MarketingLayout.scss';

type Props = {
  location: Object,
  children?: ?any,
  light?: boolean,
  borderless?: boolean,
};

function MarketingLayout(props: Props) {
  return (
    <div className="MarketingLayout">
      <div className="MarketingLayout-headerContainer">
        <div
          className={cx('MarketingLayout-header', {
            'MarkeyingLayout-header--border': !props.borderless,
          })}>
          {props.light ? (
            <HeaderLight data-test="header-light" location={props.location} />
          ) : (
            <Header data-test="header" location={props.location} />
          )}
        </div>
      </div>
      <div className="MarketingLayout-content">
        <div className="MarketingLayout-content-inner">{props.children}</div>
      </div>
    </div>
  );
}

export default MarketingLayout;
